import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const BulkModeTogglerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
`

export const BulkModeVelocityTogglerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const SingleItemTogglerContainer = styled.div`
  padding: 4px 2px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;

  path {
    fill: ${COLORS.secondarySemiDark};
  }

  p {
    color: ${COLORS.secondarySemiDark};
  }
`

export const SingleItemVelocityTogglerWrapper = styled.div`
  display: flex;
  background-color: transparent;

  @media screen and (min-width: 768px) {
    cursor: pointer;

    &:hover {
      ${SingleItemTogglerContainer} {
        background-color: ${COLORS.primarySemiLight};

        path {
          fill: ${COLORS.secondaryDark};
        }

        p {
          color: ${COLORS.secondaryDark};
        }
      }
    }
  }
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    path 0.2s ease-in-out;
`
